import React, { useContext, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import OrdersFilters from './OpenOrdersFilter/OpenOrdersFilter';
import Table from '../../../../../../Common/Table/Table';
import SkeletonWrapper from '../../../../../../hoc/SkeletonWrapper/SkeletonWrapper';
import { openOrdersCols } from './tableColumns';
import { usePromise } from '../../../../../../../hooks/usePromise/usePromise';
import { deleteTradeOrderReq } from '../../../../../../../services/hpoolService';
import './OpenOrders.scss';
import { OpenOrdersContext } from '../../../../../../Modals/EditTokensModal/EditTokensModal';
import {
  loadingIndex,
  updateFutureOrderIndex,
  useAssetsSignatures,
} from '../../../../../../../hooks/useAssetsSignatures';
import { OrdersContext } from '../../../../../../Modals/EditTokensModal/EditOrderDetails';
import { multiTypePoolManager } from '../../../../../../../constants/vpool';

const mapOrdersState = (orders = [], statusString) => orders.map((_order) => ({ ..._order, status: statusString }));

function OpenOrders({ ordersState, tableProps, isVpool }) {
  const [filterValue, setFilterValue] = useState('');

  const { selectedToken = {} } = useContext(OrdersContext);
  const { token_id: selectedTokenId } = selectedToken || {};

  const { [updateFutureOrderIndex]: updateFutureOrder, [loadingIndex]: loading } = useAssetsSignatures();
  const { getOpenOrders, openOrders: orders, openOrdersLoading } = useContext(OpenOrdersContext);

  const [deleteTrade, , deleteLoading, , deleteCount] = usePromise(deleteTradeOrderReq, {
    onSuccess: getOpenOrders,
  });
  const filterdByState = orders?.[ordersState];

  const filteredByTokenId = useMemo(
    () => filterdByState?.filter((order) => order?.token_id === selectedTokenId),
    [selectedTokenId, filterdByState?.length],
  );

  const filteredRecords = useMemo(
    () => filteredByTokenId?.filter((order) => order?.order_type.includes(filterValue)),
    [filteredByTokenId, filterValue],
  );
  const handleDelete = (tradeOrderId) => deleteTrade(tradeOrderId);

  const signMethod = (tradeOrder) => {
    updateFutureOrder(tradeOrder)?.then?.(getOpenOrders);
  };

  const signInfo = {
    signMethod,
    loading,
  };
  const statfullCols = useMemo(() => openOrdersCols({ onCancel: handleDelete, signInfo }), [signInfo]);

  const onFilterChange = (id) => setFilterValue(id);
  const allLoadings = [openOrdersLoading, deleteLoading].some((condition) => condition);

  const openOrderFilters = multiTypePoolManager(isVpool).openOrderTabs;

  useEffect(() => {
    getOpenOrders();
  }, [deleteCount]);

  return (
    <div className="open-orders-wrapper">
      <OrdersFilters filters={openOrderFilters} onChange={onFilterChange} currentFilter={filterValue} />
      <Table
        cols={statfullCols}
        dataSourse={!allLoadings ? filteredRecords : []}
        noDataText="hpool.no_orders_found"
        loading={allLoadings}
        {...tableProps}
      />
    </div>
  );
}

OpenOrders.defaultProps = {
  ordersState: 'pending',
  tableProps: {},
};

OpenOrders.propTypes = {
  ordersState: PropTypes.string,
  tableProps: PropTypes.object,
  isVpool: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ createHPool }) => ({
  hpool: createHPool?.hpool,
  isVpool: createHPool?.hpool?.is_vpool,
});

export default connect(mapStateToProps)(OpenOrders);
